"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    inputWrapper: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { lineHeight: theme.lineHeight }));
    },
    label: function (_a) {
        var theme = _a.theme;
        return ({
            display: 'block',
            marginBottom: 5,
            fontSize: 14,
            fontWeight: 500,
            color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[9],
            wordBreak: 'break-word',
        });
    },
    error: function (_a) {
        var theme = _a.theme;
        return ({
            marginTop: theme.spacing.xs / 2,
            wordBreak: 'break-word',
        });
    },
    description: function (_a) {
        var theme = _a.theme;
        return ({
            marginTop: theme.spacing.xs / 2,
            marginBottom: theme.spacing.xs / 2,
            wordBreak: 'break-word',
        });
    },
    required: function (_a) {
        var theme = _a.theme;
        return ({
            color: theme.colorScheme === 'dark' ? theme.colors.red[5] : theme.colors.red[7],
        });
    },
}, { link: true });
